/**
 * Category column + preview image swap on hover / focus within group.
 */
if (!customElements.get('aesthetic-category-nav')) {
  class AestheticCategoryNav extends HTMLElement {
    /** @type {HTMLImageElement | null} */
    #img = null;

    /** @type {HTMLElement | null} */
    #overlayTitle = null;

    /** @type {string} */
    #cta = '';

    connectedCallback() {
      this.#img = this.querySelector('[data-acn-preview-img]');
      this.#overlayTitle = this.querySelector('[data-acn-overlay-heading]');
      this.#cta = this.dataset.acnCta || '';

      const groups = this.querySelectorAll('[data-acn-group]');

      for (const group of groups) {
        if (!(group instanceof HTMLElement)) continue;

        group.addEventListener('pointerenter', () => this.#applyGroup(group));
        group.addEventListener('focusin', () => this.#applyGroup(group));
      }

      const first = this.querySelector('[data-acn-group][data-acn-preview-url]');
      if (first instanceof HTMLElement && first.dataset.acnPreviewUrl) {
        this.#applyGroup(first);
      }
    }

    /**
     * @param {HTMLElement} group
     */
    #applyGroup(group) {
      const url = group.dataset.acnPreviewUrl;
      if (!url || !this.#img) return;

      this.#img.src = url;
      const srcset = group.dataset.acnPreviewSrcset;
      if (srcset) {
        this.#img.srcset = srcset;
      } else {
        this.#img.removeAttribute('srcset');
      }

      const sizes = group.dataset.acnPreviewSizes;
      if (sizes) {
        this.#img.sizes = sizes;
      } else {
        this.#img.removeAttribute('sizes');
      }

      const alt = group.dataset.acnPreviewAlt || '';
      this.#img.alt = alt;

      if (this.#overlayTitle) {
        const heading = group.dataset.acnHeading || '';
        this.#overlayTitle.textContent = heading;
      }
    }
  }

  customElements.define('aesthetic-category-nav', AestheticCategoryNav);
}
